import { render, staticRenderFns } from "./index.vue?vue&type=template&id=248ac2af&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=248ac2af&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248ac2af",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qingchi/workspace/mimi/mer_mer_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('248ac2af')) {
      api.createRecord('248ac2af', component.options)
    } else {
      api.reload('248ac2af', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=248ac2af&scoped=true", function () {
      api.rerender('248ac2af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/decoration/customer-pricing/index.vue"
export default component.exports